import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import {
  calculateAverageCostPerRoomNight,
  calculateCostToRoomRevenueRatio,
  calculateNetAdr,
  calculateNetRevenueToRoomRevenueRatio,
  calculateOccupancyRate,
} from 'lumen/utils/net-revenue/metrics';
import type { NetRevenueReference } from 'lumen/utils/net-revenue/types';

export default class NetRevenueTotals extends Model {
  [Type] = 'net-revenue/totals' as const;

  @attr('number') declare capacity: number;
  @attr('net-revenue-money') declare cost: number | null;
  @attr('net-revenue-money') declare netRevenue: number;
  @attr('net-revenue-references') declare references: NetRevenueReference[];
  @attr('number') declare roomNights: number;
  @attr('net-revenue-money') declare roomRevenue: number;

  get avgCost(): number {
    return (
      calculateAverageCostPerRoomNight(this.cost ?? 0, this.roomNights) ?? 0
    );
  }

  get costPercent(): number {
    return (
      calculateCostToRoomRevenueRatio(this.cost ?? 0, this.roomRevenue) ?? 0
    );
  }

  get netAdr(): number {
    return calculateNetAdr(this.netRevenue, this.roomNights) ?? 0;
  }

  get netRevenuePercent(): number {
    return (
      calculateNetRevenueToRoomRevenueRatio(
        this.netRevenue,
        this.roomRevenue,
      ) ?? 0
    );
  }

  get occupancy(): number {
    return calculateOccupancyRate(this.roomNights, this.capacity) ?? 0;
  }

  referenceByType(type: string): NetRevenueReference | undefined {
    return this.references?.find((reference) => reference.type === type);
  }
}
